import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { Center, Flex, Icon, IconButton, Text } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Calendar, List } from '../icons/icons'
import { useUserWrapperContext } from '../wrappers/UserWrapper'

const UserNotificationHeader = () => {
  const { topCollapsed, notificationScreen, setNotificationScreen } = useUserWrapperContext()

  const transition = '0.2s ease-out'
  const navigate = useNavigate()

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }
  const isEvents = location.href.includes('user/events')
  useEffect(() => {
    if (isEvents) {
      setNotificationScreen('events')
    } else {
      setNotificationScreen('notifications')
    }
  }, [])

  return (
    <Flex
      h={topCollapsed ? '0' : '32px'}
      mb={topCollapsed ? '0' : '10px'}
      justifyContent="space-between"
      transition={transition}
      overflow="hidden"
      position="relative"
    >
      <Center w="100%" h="100%" position="absolute" left="0" top="0">
        <Text variant="title" fontSize="lg">
          {notificationScreen === 'notifications' ? 'Inbox' : 'My Events'}
        </Text>
      </Center>
      <IconButton
        minW="32px"
        h="32px"
        variant="light"
        aria-label="back"
        onClick={() => {
          triggerHapticFeedback(ImpactStyle.Medium)
          if (notificationScreen === 'notifications' || isEvents) {
            navigate(-1)
          } else {
            setNotificationScreen('notifications')
          }
        }}
        icon={
          <Icon width="20px" height="19px" viewBox="0 0 23 20">
            <ArrowLeft color="#171C22" />
          </Icon>
        }
      />

      {notificationScreen === 'events' && (
        <IconButton
          minW="32px"
          h="32px"
          variant="light"
          aria-label="back"
          onClick={() => setNotificationScreen('calendar')}
          icon={
            <Icon width="20px" height="20px" viewBox="0 0 24 24" color="#171C22">
              <Calendar />
            </Icon>
          }
        />
      )}
      {notificationScreen === 'calendar' && (
        <IconButton
          minW="32px"
          h="32px"
          variant="light"
          aria-label="back"
          onClick={() => setNotificationScreen('events')}
          icon={
            <Icon width="18px" height="18px" viewBox="0 0 20 15">
              <List color="#171C22" />
            </Icon>
          }
        />
      )}
    </Flex>
  )
}

export default UserNotificationHeader
